import gql from 'graphql-tag';

const activateOnboardingQueueRecordMutation = gql`
  mutation ActivateOnboardingQueueRecord($input: ActivateOnboardingQueueRecordInput!) {
    activateOnboardingQueueRecord(input: $input) {
      success
      errors
      onboardingQueueRecord {
        flatRateOfferId
        status
        reason
        completedAt
        updatedAt
        updatedBy
      }
    }
  }
`;

export default activateOnboardingQueueRecordMutation;
